export default __webpack_public_path__ + "static/media/cert-general-staff-a-cpttm-sc.664f73db.jpg";